
  import { css } from 'lit';
  export const styles = css`:host([active]:hover){background:var(--hover-item-background);color:var(--hover-item-text-color)}:host([active]){outline:.0625rem solid var(--border-color);outline-offset:-0.0625rem}`;
  